import React from 'react';
import { Button } from '../ui/button';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_electric-essentials/artifacts/ond30d68_IMG-20250928-WA0020.jpg";

export const Hero = ({ onNavigate }) => (
  <section id="home" className="pt-20 pb-12" data-testid="hero-section">
    <div className="w-full px-2 md:px-8">
      <img
        src={HERO_IMAGE}
        alt="Derby Premium Electrical Products"
        className="w-full h-auto rounded-lg"
      />
    </div>
    <div className="container mx-auto px-4">
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
        <Button
          size="lg"
          className="bg-amber-500 hover:bg-amber-600 text-black font-semibold transition-colors"
          onClick={() => onNavigate('products')}
          data-testid="hero-explore-products-btn"
        >
          Explore Products
        </Button>
        <Button
          size="lg"
          variant="outline"
          className="border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black transition-colors"
          onClick={() => onNavigate('contact')}
          data-testid="hero-get-in-touch-btn"
        >
          Get In Touch
        </Button>
      </div>
    </div>
  </section>
);
